<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('邀请人用户ID')" prop="inviterUserId">
                <a-input-number v-model="queryParam.inviterUserId" :min="1" :precision="0" style="width: 100%" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('被邀请人用户ID')" prop="inviteeUserId">
                <a-input-number v-model="queryParam.inviteeUserId" :min="1" :precision="0" style="width: 100%" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker
                  v-model="queryParam.createBeginTime"
                  style="width: 100%"
                  :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker
                  v-model="queryParam.createEndTime"
                  style="width: 100%"
                  :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:invitereward:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <a-table
        row-key="id"
        :loading="loading"
        :size="tableSize"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '150%', y: tableScrollY }"
      >
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">{{ $t('已处理') }}</a-tag>
          <a-tag v-else>{{ text }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">{{ parseTime(text) }}</span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        :page-size-options="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :show-total="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { parseTime } from '@/utils/ruoyi'
import { tableMixin } from '@/store/table-mixin'
import { pageInviteReward } from '@/api/user/inviteReward'

export default {
  name: 'InviteReward',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      loading: false,
      total: 0,
      pageSizeOptions: ['10', '20', '50', '100'],
      queryParam: {
        inviterUserId: undefined,
        inviteeUserId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('邀请人用户ID'), dataIndex: 'inviterUserId', align: 'center' },
        { title: this.$t('邀请人昵称'), dataIndex: 'inviterNickName', ellipsis: true, align: 'center' },
        { title: this.$t('邀请人手机号'), dataIndex: 'inviterMobile', ellipsis: true, align: 'center' },
        { title: this.$t('被邀请人用户ID'), dataIndex: 'inviteeUserId', align: 'center' },
        { title: this.$t('被邀请人昵称'), dataIndex: 'inviteeNickName', ellipsis: true, align: 'center' },
        { title: this.$t('被邀请人手机号'), dataIndex: 'inviteeMobile', ellipsis: true, align: 'center' },
        { title: this.$t('奖励金额'), dataIndex: 'rewardAmount', align: 'center' },
        { title: this.$t('状态'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: this.$t('余额流水ID'), dataIndex: 'balanceRecordId', align: 'center' },
        { title: this.$t('创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: this.$t('备注'), dataIndex: 'remark', ellipsis: true, align: 'center' }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    moment,
    parseTime,
    getTotal (total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList () {
      this.loading = true
      pageInviteReward(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        inviterUserId: undefined,
        inviteeUserId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleExport () {
      const that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('user/invite/reward/export', that.queryParam, `邀请注册奖励_${new Date().getTime()}.xlsx`)
        }
      })
    }
  }
}
</script>
